export default __webpack_public_path__ + "static/media/58.3351d357.jpg";